import { Component, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
    selector: 'app-session-expired',
    templateUrl: './session-expired.component.html',
    styleUrls: ['./session-expired.component.css']
})
@TraceClassDecorator()
export class SessionExpiredComponent implements OnInit {

    slug: string = "";
    logo_url: string = "";
    constructor(private readonly utilitiesService: UtilitiesService,
        private readonly providerstateService: ProviderStateService
    ) {}

    ngOnInit() {
        this.slug = this.providerstateService.getProviderSlug();
        this.logo_url = this.providerstateService.getLogoUrl();
    }

    async openLink(
        base_url_name: string,
        link: string,
        target: string
    ): Promise<void> {
        await this.utilitiesService.openWebsiteLinks(
            base_url_name,
            link,
            target
        );
    }
}
